import { ClassroomAttendanceService } from "../classroomAttendance/classroomAttendance.service";

import { ClassroomClassroomAttendanceComponent } from "../classroomAttendance/classroomAttendance.component";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserService } from "../../../shared/services/user.service";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { HomeService } from "./home.service";
import { StringRequest } from "../../sysadmin/services/StringRequest";

import * as moment from "moment";

@Component({
	selector: "caass-classroom-home",
	templateUrl: "./home.component.html",
	styles: [
		`
			.one {
				display: flex;
			}
			.two {
				flex: 50%;
				padding: 10px;
			}
			.lables {
				display: inline;
				padding: 60px;
			}
			.dropbtn {
				background-color: #4caf50;
				color: white;
				padding: 16px;
				font-size: 16px;
				border: none;
			}

			.dropdown {
				position: relative;
				display: inline-block;
			}

			.dropdown-content {
				display: none;
				position: absolute;
				background-color: #f1f1f1;
				min-width: 160px;
				box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
				z-index: 1;
			}

			.dropdown-content a {
				color: black;
				padding: 12px 16px;
				text-decoration: none;
				display: block;
			}

			.dropdown-content a:hover {
				background-color: #ddd;
			}

			.dropdown:hover .dropdown-content {
				display: block;
			}

			.dropdown:hover .dropbtn {
				background-color: #3e8e4;
			}
		`,
	],
})
export class ClassroomHomeComponent implements OnInit, OnDestroy {
	constructor(private homeService: HomeService, private userService: UserService, private classroomService: ClassroomAttendanceService) {}

	ngOnInit() {
		this.PeriodGetList();
		this.pastPeriodGetList();
		this.showAttendance = false;
		this.user = this.userService.getCurrentUser();
		this.multipleSection = false;
		this.subscriptionLoadata = this.classroomService.onLoadata().subscribe((response) => {
			this.StudentGetList();
		});

		this.subscriptionSaveAttendanceCompleted = this.classroomService.onSaveAttendanceCompleted().subscribe((response) => {
			this.checkAttendanceOfPeriod();
		});

		/*this.insertMessageSubscrition = Observable.interval(500000)
      .takeWhile(() => true)
      .subscribe(() => this.notifyInstructorInsert());

    this.checkAttendancePeriodColorSubscription = Observable.interval(500000)
      .takeWhile(() => true)
      .subscribe(() => this.checkAttendanceOfPeriod());*/
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscriptionLoadata.unsubscribe();
		this.subscriptionSaveAttendanceCompleted.unsubscribe();
		//this.insertMessageSubscrition.unsubscribe();
		//this.checkAttendancePeriodColorSubscription.unsubscribe();
	}

	/////////////////////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////////////////////

	LoadingPeriods: any = true;

	StartTime: any;
	SchoolID: any = -1;

	sectionList: any = [];
	pastSectionList: any = [];
	periodList: any = [];
	pastPeriodList: any = [];
	studentList: any = [];
	instructorSectionsList: any = [];

	newPeriodList: any = [];
	periodColorList: any = [];
	perlist: any = [];
	aList: any = ["1", "2", "3"];
	user: any;
	attendanceTaken = false;
	courseDetail = false;
	pastAttendance = false;
	diffInMs: number;
	PeriodID: any;
	multipleSection = false;
	attendanceList: any = [];
	InstructorCD = "406_32998";
	SectionID: any;
	PleaseSelect = false;
	pastRecord = false;
	showAttendance: boolean;
	//attendaceComponent:boolean;
	classDate = new Date();
	pastDate = new Date();
	currentDate = new Date();
	insertMessageSubscrition: any;
	checkAttendancePeriodColorSubscription: any;
	filterargs: any;

	// classDate = "Mon Oct 01 2018 10:10:54 GMT-0400 (Eastern Daylight Time)";
	AllSections = 0;
	SelectedPeriodID = 0;

	SectionScheduleDetailID = 0;
	filteredSectionList: any[];
	subscriptionLoadata: Subscription;
	subscriptionSaveAttendanceCompleted: Subscription;

	/////////////////////////////////////////////////////////////////////////////////////////////

	private PeriodGetList() {
		this.LoadingPeriods = true;

		var result = this.homeService.PeriodGetList(moment(this.classDate).format("MM/DD/YYYY"));

		result.subscribe(
			(response: any) => {
				this.LoadingPeriods = false;

				this.periodList = response;

				if (!(this.periodList === undefined || this.periodList.length == 0)) {
					this.checkAttendanceOfPeriod();
				}
			},

			(error) => {
				this.LoadingPeriods = false;
			}
		);
	}

	private pastPeriodGetList() {
		var result = this.homeService.PeriodGetList(moment(this.pastDate).format("MM/DD/YYYY"));

		result.subscribe(
			(response: any) => {
				this.pastPeriodList = response;

				if (this.pastPeriodList.length > 1) {
					this.pastPeriodList.unshift({
						PeriodId: 0,
						PeriodDesc: "Choose Period",
					});
				}

				if (this.pastPeriodList.length == 1) {
					this.SelectedPeriodID = this.pastPeriodList[0].PeriodID;
				}

				this.pastSectionGetList();
			},
			(error) => {}
		);
	}

	checkAttendanceOfPeriod() {
		if (this.periodList && this.periodList.length > 0) {
			for (let i of this.periodList) {
				this.GetAttendance(i.PeriodNo);
			}
		} else return;
	}

	private GetAttendance(periodNo) {
		var man;

		let parms: StringRequest = {
			str: periodNo,
		};

		var result = this.homeService.GetAttendance(parms);
		result.subscribe(
			(response: any) => {
				this.attendanceList = [];
				this.newPeriodList = [];

				if (response && response.length > 0) {
					this.attendanceTaken = true;
					this.attendanceList = response;

					var pp = this.attendanceList[0].c_date;
					this.newPeriodList.push({
						PeriodNo: periodNo,
						c_date: pp,
					});
					man = this.newPeriodList[0].c_date;
					var period = this.periodList.filter((a) => {
						return a.PeriodNo == periodNo;
					});
					period[0].c_date = man;
					period[0].buttonColor = "green";
				} else {
					var period = this.periodList.filter((a) => {
						return a.PeriodNo == periodNo;
					});
					period[0].buttonColor = this.periodColor(periodNo);
				}
			},
			(error) => {}
		);
	}

	private periodColor(periodNo) {
		var period = this.periodList.filter((a) => {
			return a.PeriodNo == periodNo;
		});
		var colorb = "";

		var start2 = moment(period[0].StartTime).format("HH:mm:ss");
		var end2 = moment(period[0].EndTime).format("HH:mm:ss");

		var current2 = moment(this.classDate).format("HH:mm:ss");

		var start1 = start2.split(":");
		var end1 = end2.split(":");
		var current1 = current2.split(":");

		var start = +start1[0] * 60 * 60 + +start1[1] * 60 + +start1[2];
		var end = +end1[0] * 60 * 60 + +end1[1] * 60 + +end1[2];
		var current = +current1[0] * 60 * 60 + +current1[1] * 60 + +current1[2];

		if (start > current) {
			colorb = "yellow";
		} else if (current > end) {
			colorb = "red";
		} else if (current > start && end > current) {
			colorb = "rgb(65, 180, 225)";
		}

		return colorb;
	}
	private notifyInstructorInsert() {
		var currentT = new Date();
		var currentTime = moment(currentT).format("HH:mm:ss");
		if (this.periodList && this.periodList.length > 0) {
			for (let i of this.periodList) {
				var actualPeriodEndAt = i.EndTime;
				var periodEndAt = moment(actualPeriodEndAt).format("HH:mm:ss");
				var end1 = periodEndAt.split(":");
				var current1 = currentTime.split(":");
				var end = +end1[0] * 60 * 60 + +end1[1] * 60 + +end1[2];
				var current = +current1[0] * 60 * 60 + +current1[1] * 60 + +current1[2];
				if (current > end) {
					this.getSectionForInsMessage(i.PeriodID);
				}
			}
		} else return;
	}
	private getSectionForInsMessage(periodID) {
		var result = this.homeService.SectionGetList(periodID, moment(this.classDate).format("MM/DD/YYYY"));

		result.subscribe(
			(response: any) => {
				this.instructorSectionsList = response;

				if (this.instructorSectionsList.length > 1) {
					for (let i of this.instructorSectionsList) {
						//insert in instructor message
						this.insertMessage(i.SectionScheduleDetailID);
					}
				} else {
					this.insertMessage(this.instructorSectionsList[0].SectionScheduleDetailID);
				}
			},
			(error) => {}
		);
	}
	private insertMessage(sectionScheduleDetailID) {
		var currentTime = new Date();
		var currentDate = moment(currentTime).format("YYYY-MM-DD");
		var result = this.homeService.InsertInstructorMessage(sectionScheduleDetailID, currentDate);
		result.subscribe(
			(response: any) => {},
			(error) => {}
		);
	}

	//
	// Click on a period
	//
	private SectionGetList(PeriodID) {
		// console.log("Button clicked w/ ID: " + PeriodID);

		this.SectionScheduleDetailID = 0;
		this.multipleSection = false;

		var result = this.homeService.SectionGetList(PeriodID, moment(this.classDate).format("MM/DD/YYYY"));

		result.subscribe(
			(response: any) => {
				// console.log("Response:");
				// console.log(response);

				var st = response[0].ClassStartTime;
				// console.log("Start Time");
				// console.log(st);

				this.courseDetail = true;
				this.sectionList = response;

				if (this.sectionList.length > 1) {
					this.multipleSection = true;
				} else {
					this.multipleSection = false;
					this.SectionScheduleDetailID = this.sectionList[0].SectionScheduleDetailID;
					this.filteredSectionList = this.sectionList[0];

					this.StartTime = this.sectionList[0].ClassStartTime;
					this.SchoolID = this.sectionList[0].SchoolID;

					this.StudentGetList();
				}
			},
			(error) => {}
		);
	}

	private pastSectionGetList() {
		this.SectionScheduleDetailID = 0;

		if (!this.SelectedPeriodID) {
			this.pastSectionList = [];
			return;
		} else {
			var result = this.homeService.SectionGetList(this.SelectedPeriodID, moment(this.pastDate).format("MM/DD/YYYY"));

			result.subscribe(
				(response: any) => {
					this.pastSectionList = response;

					if (this.pastSectionList.length > 1) {
						this.pastSectionList.unshift({
							SectionScheduleDetailID: 0,
							CourseDesc: "Choose Section",
						});
					}
					if (this.pastSectionList.length > 0) {
						this.SectionScheduleDetailID = this.pastSectionList[0].SectionScheduleDetailID;
					}
				},
				(error) => {}
			);
		}
	}
	private StudentGetList() {
		// console.log("Student Get List after button pressed");

		this.PleaseSelect = false;

		if (this.pastRecord) {
			this.classDate = this.pastDate;
			var params = {
				SectionScheduleDetailID: this.SectionScheduleDetailID,
				classDate: moment(this.classDate).format("MM/DD/YYYY"),
				AllSections: this.AllSections,
				StartTime: this.StartTime,
				SchoolID: this.SchoolID,
			};
			this.classroomService.sectionChanged(params);
		} else {
			this.classDate = this.currentDate;
			var params = {
				SectionScheduleDetailID: this.SectionScheduleDetailID,
				classDate: moment(this.classDate).format("MM/DD/YYYY"),
				AllSections: this.AllSections,
				StartTime: this.StartTime,
				SchoolID: this.SchoolID,
			};
			this.classroomService.sectionChanged(params);
		}
	}
	onSectionChange(newSection) {
		this.SectionScheduleDetailID = newSection;
		this.StudentGetList();
	}
	onPeriodChange(newPeriodID) {
		this.SelectedPeriodID = newPeriodID;
		this.pastSectionGetList();
	}
	onclassDateChange(newClassDate) {
		this.pastDate = newClassDate;
		this.pastPeriodGetList();
	}
	showPastRecord() {
		this.pastRecord = true;
	}
	btnClick(event: any, sectionScheduleDetailID) {
		this.SectionScheduleDetailID = sectionScheduleDetailID;
		this.filterargs = {
			SectionScheduleDetailID: this.SectionScheduleDetailID,
		};
		var filteredsection = this.sectionList.filter((a) => {
			return a.SectionScheduleDetailID == sectionScheduleDetailID;
		});
		this.filteredSectionList = filteredsection[0];

		/* if (this.SelectedPeriodID == 0 || this.SectionScheduleDetailID == 0) {
      this.PleaseSelect = true;
    } else {
      //this.StudentGetList();
    }*/
		this.StudentGetList();
	}
	viewAttendance(action) {
		if (action == 1) {
			if (this.SelectedPeriodID == 0 || this.SectionScheduleDetailID == 0) {
				this.PleaseSelect = true;
			} else {
				this.StudentGetList();
			}
		} else {
			this.pastRecord = false;
		}
	}
	onhover() {
		this.pastAttendance = true;
	}
	nohover() {
		this.pastAttendance = false;
	}
}
